import {
  ChangePasswordSchema,
  LoginSchema,
  RegisterSchema,
} from "@/schemas/auth";
import { ApiResponse } from "@/services/api-service";
import axiosInstance from "@/services/axios-instance";
import {
  isAuthenticated as checkAuth,
  type TokenPayload,
  useAuthStore,
} from "@/store/auth-store";
import { z } from "zod";

export type LoginCredentials = z.infer<typeof LoginSchema>;

export type RegisterData = z.infer<typeof RegisterSchema>;

export type ChangePasswordData = z.infer<typeof ChangePasswordSchema>;

/**
 * Login user
 */
export const login = async (
  credentials: LoginCredentials,
): Promise<ApiResponse<TokenPayload>> => {
  try {
    const response = await axiosInstance.post<ApiResponse<TokenPayload>>(
      "/auth/sign-in",
      {
        nonce: "string",
        payload: {
          username: credentials.username,
          password: credentials.password,
        },
      },
    );

    console.log("result", response);

    // Store tokens in Zustand
    useAuthStore
      .getState()
      .setTokens(response.data.payload, credentials.rememberMe);

    useAuthStore
      .getState()
      .setUser({ username: credentials.username, role: "admin" });

    console.log("Updated Zustand state:", useAuthStore.getState());

    return response.data;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
};

/**
 * Register user
 */
export const register = async (
  data: RegisterData,
): Promise<ApiResponse<TokenPayload>> => {
  try {
    const response = await axiosInstance.post<ApiResponse<TokenPayload>>(
      "/auth/register",
      { nonce: "string", payload: data },
    );

    // Don't store tokens on registration - user should log in
    return response.data;
  } catch (error) {
    console.error("Registration error:", error);
    throw error;
  }
};

/**
 * Change password
 */
export const changePassword = async (data: ChangePasswordData) => {
  try {
    await axiosInstance.patch("/users", {
      nonce: "string",
      payload: data,
    });
  } catch (error) {
    console.error("Change password error:", error);
    throw error;
  }
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = (): boolean => {
  return checkAuth();
};
